import React from 'react';
import RedirectOffSite from 'app/ui/route/RedirectOffSite';
import { getAssignmentCreatorUrlBase } from 'app/api/redux-watson/watson-config-selectors';
import { connect } from 'react-redux';
import { getBookshelfViewAssignmentUrl } from 'app/ui/pages/shared/url-builder';
import AssetActivator from 'app/ui/bridge/AssetActivator';

export const NEW = 'new';
export const EDIT = 'edit';
export const VIEW = 'view';

function AssignmentCreatorRedirect({ match, urlBase }) {
  const { vbid, assignmentId, mode } = match.params;

  let finalUrl = `${urlBase}/#/books/${vbid}/assignment/`;

  if (mode === NEW) {
    finalUrl += NEW;
  } else if (mode === EDIT) {
    finalUrl += `${assignmentId}/${EDIT}`;
  } else if (mode === VIEW) {
    finalUrl = getBookshelfViewAssignmentUrl(urlBase, vbid, assignmentId);
  }

  return (
    <AssetActivator vbid={vbid}>
      <RedirectOffSite to={finalUrl} params={{ sso: true, newWin: true }} />
    </AssetActivator>
  );
}

export default connect(state => ({
  urlBase: getAssignmentCreatorUrlBase(state),
}))(AssignmentCreatorRedirect);
